import { render, staticRenderFns } from "./UserDriverData.vue?vue&type=template&id=e4d7040c&scoped=true&"
import script from "./UserDriverData.vue?vue&type=script&lang=js&"
export * from "./UserDriverData.vue?vue&type=script&lang=js&"
import style0 from "./UserDriverData.vue?vue&type=style&index=0&id=e4d7040c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4d7040c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
